export const AnnouncementBar = () => {
  return (
    <div
      data-testid="announcement-bar"
      className="bg-champagne text-espresso text-[11px] sm:text-xs py-2.5 text-center font-medium tracking-[0.18em] uppercase"
    >
      FREE SHIPPING OFFER*
    </div>
  );
};
